import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { KYBProgressStatusEnum } from 'anchor-kyb-service/types';
import { Button, Callout, Typography } from 'seagull';
import { openInNewTabProps } from '~/constants';
import { useStore } from '~/contexts';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';
import { useLocaleKeys } from '~/i18n';
import { selectors } from '~/store/state-selectors';
import styles from './HomePage.module.scss';
export function MissingColumnBankAccountBanner() {
    const { t: homeTexts } = useLocaleKeys('pages.homePage');
    const showMissingColumnBankAccountBanner = useStore(selectors.showMissingColumnBankAccountBanner);
    const { KYB_VERIFICATION } = useFeatureFlags();
    return showMissingColumnBankAccountBanner && !KYB_VERIFICATION ? /*#__PURE__*/ _jsx(Callout, {
        hideIcon: true,
        intent: "warning",
        testId: "missing-column-bank-account-banner",
        className: styles.missingColumnBankAccountBanner,
        withAction: /*#__PURE__*/ _jsx(Button, _object_spread_props(_object_spread({
            as: "a",
            href: "https://book.avoma.com/anchor/3-day-ach-migration",
            skin: "darkSecondary"
        }, openInNewTabProps), {
            children: homeTexts.scheduleCall()
        })),
        children: homeTexts.missingColumnBankAccountMessage()
    }) : null;
}
export function EnablePaymentsBanner() {
    const { t: homeTexts } = useLocaleKeys('pages.homePage');
    const hasDisabledPayments = useStore(selectors.user.hasDisabledPayments);
    const personaKYBStatus = useStore((s)=>{
        var _s_personaKYBStatus_data;
        return (_s_personaKYBStatus_data = s.personaKYBStatus.data) === null || _s_personaKYBStatus_data === void 0 ? void 0 : _s_personaKYBStatus_data.status;
    });
    const { KYB_VERIFICATION } = useFeatureFlags();
    const isKYBApproved = personaKYBStatus === KYBProgressStatusEnum.Approved;
    return hasDisabledPayments && isKYBApproved && KYB_VERIFICATION ? /*#__PURE__*/ _jsx(Callout, {
        hideIcon: true,
        intent: "warning",
        testId: "enable-payments-banner",
        className: styles.enablePaymentsBanner,
        withAction: /*#__PURE__*/ _jsx(Button, _object_spread_props(_object_spread({
            as: "a",
            testId: "enable-payments-banner-button",
            href: "https://book.avoma.com/anchor/enable-payments/",
            skin: "darkSecondary"
        }, openInNewTabProps), {
            children: homeTexts.scheduleCall()
        })),
        children: /*#__PURE__*/ _jsx(Typography, {
            children: homeTexts.enablePaymentsMessage()
        })
    }) : null;
}
